<div class="flex">
  <h2>Opkrævninger</h2>

  @if (isAdmin || isSuperUser) {
    <app-select-filter
      class="margin-left-auto"
      [filterOptions]="afregningsTypesKeys"
      (filterChange)="selectedAfregningType = $event"
      cachename="opkraeevninger"
    ></app-select-filter>
  }
</div>
<table mat-table matSort [dataSource]="dataSource" class="mat-elevation-z0">
  <ng-container matColumnDef="overfoertDate">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Overført til G4</th>
    <td mat-cell *matCellDef="let op">{{ op.overfoertG4Dato | date: 'dd.MM.yyyy' }}</td>
  </ng-container>
  <ng-container matColumnDef="opkraevningDate">
    <th
      mat-header-cell
      *matHeaderCellDef
      mat-sort-header
      matTooltip="På serviceordre = leveringsdato. For abn = opkrævningsdato. For slutopgørelse = effektiv dato."
      >
      Købsdato
    </th>
    <td mat-cell *matCellDef="let op">{{ op.opkraevningDate | date: 'dd.MM.yyyy' }}</td>
  </ng-container>

  <ng-container matColumnDef="periode">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Periode</th>
    <td mat-cell *matCellDef="let op">
      {{ $safeNavigationMigration(op.serviceinterval?.startDate) | date: 'dd.MM.yyyy' }} - {{ $safeNavigationMigration(op.serviceinterval?.endDate) | date: 'dd.MM.yyyy' }}
    </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
    <td mat-cell *matCellDef="let op">{{ op.type }}</td>
  </ng-container>

  <ng-container matColumnDef="opkraevningScope">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Modtager</th>
    <td mat-cell *matCellDef="let op">{{ op.opkraevningScope == 'Partner' ? 'Partner' : 'Kunde' }}</td>
  </ng-container>

  <ng-container matColumnDef="bilagsnr">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Bilagsnr</th>
    <td mat-cell *matCellDef="let op">{{ op.bilagsnr }}</td>
  </ng-container>

  <ng-container matColumnDef="beloebExclMoms">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>Totalbeløb/fakturabeløb</th>
    <td mat-cell *matCellDef="let op">
      @if (serviceaftale.kunde?.kundetype.id == 1) {
        <span>{{ op.beloebMedMoms | dkCurrency }} inkl. moms</span>
      }
      @if (serviceaftale.kunde?.kundetype.id == 2) {
        <span>{{ op.beloebExclMoms | dkCurrency }} ekskl. moms</span>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="serviceordreNo">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>ServiceordreNo</th>
    <td mat-cell *matCellDef="let op">{{ op.serviceordreNo }}</td>
  </ng-container>

  <ng-container matColumnDef="kreditnota">
    <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
    <td mat-cell *matCellDef="let op">
      @if (op.type != 'Kreditnota' && !op.hasKreditering && op.type != 'Tilbageførsel' && op.type != 'Slutopgørelse, abn') {
        <button
          mat-raised-button
          type="button"
          class="btn-trans mat-elevation-z0"
          (click)="kreditnota($event, op)"
          [disabled]="!canKreditnota"
          >
          @switch (op.opkraevningScope) {
            @case (this.opkraevningScopePartner) {
              Tilbagefør
            }
            @default {
              Kreditnota
            }
          }
        </button>
      }
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="columns"></tr>
  <tr
    mat-row
    (click)="onRowClick(row)"
    class="cursor-pointer"
    [class.partner-row]="row.opkraevningScope == this.opkraevningScopePartner"
    *matRowDef="let row; columns: columns; index as i"
  ></tr>
</table>
